import { useTranslation } from 'next-i18next'
import React from 'react'

import { Head, BankingServiceUnavailable } from '../../../src/component'
import { TrackPageViewed } from '../../../src/integrations/monitoring'
import { CheckoutPage } from '../../../src/model'

export const BankingServiceUnavailablePage: CheckoutPage = () => {
  const { t } = useTranslation()

  const pageTitle = t('common:brandName')

  return (
    <>
      <Head title={pageTitle} />
      <BankingServiceUnavailable />
      <TrackPageViewed />
    </>
  )
}
